import { Box, Container } from '@mui/material';
import React from 'react';

import { aspectRatio } from 'utils/styles.utils';

import { gradients } from 'constants/gradients.constants';
import { PageEventFragment } from 'types/api/dato-operations.types';

import { AffiliateNotice } from 'components/@affiliate/AffiliateNotice';
import DatoImage from 'components/@common/DatoImage';
import EventHeader from 'components/@events/EventHeader';

interface Props {
  event: PageEventFragment;
}

const EventImageBackgroundHeader = ({ event }: Props) => {
  return (
    <Box
      sx={{
        pt: 9,
        pb: 5,
        display: { md: 'none' },
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <DatoImage
        data={event.cover}
        priority
        fill
        style={{
          objectFit: 'cover',
          filter: 'blur(30px)',
          objectPosition: 'top',
          transform: 'scale(1.3)',
        }}
        sizes="512px"
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          width: '100%',
          height: '100%',
          ...gradients.bottomToTop,
        }}
      />
      <Container>
        <Box
          mt="24px"
          mb="48px"
          sx={{
            zIndex: 1,
            position: 'relative',
          }}
        >
          <AffiliateNotice eventName={event.title} />
        </Box>

        <Box
          sx={{
            display: 'flex',
            gap: 2,
          }}
        >
          <Box
            sx={{
              position: 'relative',
              overflow: 'hidden',
              borderRadius: 4,
              height: 80,
              width: 80,
              minWidth: 80,
              pr: 2,
              ...aspectRatio(1, 1),
            }}
          >
            <DatoImage
              data={event.cover}
              priority
              fill
              style={{ objectFit: 'cover' }}
              sizes="512px"
            />
          </Box>
          <EventHeader event={event} />
        </Box>
      </Container>
    </Box>
  );
};

export default EventImageBackgroundHeader;
